<template>
    <div>
        <NavBar />
        <LoadStatus/>
        <div  v-if="this.$store.getters.Loaded && this.$store.getters.GetBlock.archive" class="uk-container uk-container-center uk-text-center  uk-position-z-index-negative" style="background-image: none;" uk-scrollspy="cls:uk-animation-slide-bottom;">
        <h2 class="uk-heading uk-margin-xlarge-top">{{this.$store.getters.GetText.archive.title[this.$store.getters.Lang]}}</h2>
        <div class="uk-margin-medium-top">
        <ArchiveList/>    
        </div>
        <div class="uk-tab-center">           
          
    <div v-if="(uniqueYears.length>1) && !this.id" class="uk-margin uk-width-2-3@m uk-align-center">
      <select v-model="year" class="uk-select" aria-label="Select">
          <option v-for="year in uniqueYears" :key="year">{{ year }}</option>        
      </select>
    </div>

    <!--div v-if="(uniqueSection[this.$store.getters.Lang].length>1) && !this.id" class="uk-margin uk-width-2-3@m uk-align-center">
      <select v-model="section" class="uk-select" aria-label="Select">
          <option v-for="(sec,index) in uniqueSection[this.$store.getters.Lang]" :key="index" :selected="{'selected': index === 0}">{{ sec }}</option>        
      </select>
    </div-->

    
    <div v-if="this.$store.getters.GetText[year].title">      
      <div v-if="!this.id" class="uk-width-2-3@m uk-align-center">
        <h4 v-html="this.$store.getters.GetText[year].title[this.$store.getters.Lang]"></h4>
        <p v-html="this.$store.getters.GetText[year].description[this.$store.getters.Lang]"></p>
      </div>
      <div v-else class="uk-width-2-3@m uk-align-center">
        <h4 v-html="this.$store.getters.GetText[year].title[this.$store.getters.Lang]"></h4>
        <p v-html="this.$store.getters.GetText[year].description[this.$store.getters.Lang]"></p>
      </div>
      <div v-if="!this.id" class="uk-margin uk-align-center">
      <div class="uk-inline uk-width-2-3@m">
            <a class="uk-form-icon uk-form-icon-flip" uk-icon="icon: search"></a>
            <input v-model="search" class="uk-input" type="text" aria-label="Clickable icon">
        </div>        
    </div>
      <!--ul uk-accordion class="uk-width-2-3@m uk-align-center">
        <li v-for="(section,index) in uniqueSection[this.$store.getters.Lang]" :key="section" :class="{'uk-open': index === 0}" >
          <a class="uk-accordion-title uk-text-left" href="#">{{section}}</a>
            <div class="uk-accordion-content">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
            </div>
        </li>
      </ul-->

    <!--li v-for="publication in filteredPublications()" :key="publication.id">        
        <h4>{{ publication.title[this.$store.getters.Lang] }}</h4>
        <p>{{ publication.author[this.$store.getters.Lang] }}</p>
        <p>{{ publication.year }}</p>        
    </li-->

    <div v-if="pubView.length>0">
    <div class=" uk-border-rounded uk-card uk-card-default uk-card-body uk-width-2-3@m uk-margin uk-animation-scale-down uk-align-center uk-text-left" v-for="report in pubView" :key="report.publication_id">        
        <div class="uk-card-badge uk-label uk-border-rounded">{{ report.section[this.$store.getters.Lang]}}</div>   
        <h4 class="uk-margin">{{report.title[this.$store.getters.Lang]}}</h4>        
        <h5 class="uk-text-italic uk-remove-margin">{{report.author[this.$store.getters.Lang]}}</h5>   
        <p v-if="report.co_author[this.$store.getters.Lang]" class="uk-article-meta uk-text-italic">{{report.co_author[this.$store.getters.Lang]}}</p>
        <hr>
        <div class="uk-height-max-medium uk-overflow-auto">
            <p class="uk-text-justify" v-html="report.annotation[this.$store.getters.Lang]"></p>
        </div>                
    
        <hr>
        <!-- Files -->
        <div  v-if="report.file_ru || report.file_en" class="uk-text-left uk-width-1-2@m">                    
            <div>
                <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.abstract[this.$store.getters.Lang]}}:</label><br>
                <ul>
                <li v-if="report.file_ru">
                    <a  :href="report.file_ru.url"  title="Download">{{report.file_ru.name}}</a>
                </li>                            
                <li v-if="report.file_en" >
                    <a :href="report.file_en.url"  title="Download">{{report.file_en.name}}</a>
                    </li>
                </ul>                                      
            </div>             
        </div>
        <!-- Buttons -->
        <div v-if="this.$store.getters.GetBlock.reports" class="uk-text-left">        
          <div>
            <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.archive.link[this.$store.getters.Lang]}}</label><br>  
            <a :href="report.link" class="uk-button" uk-icon="icon: link; ratio: 2" target="_blank" title="Go to" ></a>
            <!--a :href="report.link" class="text-dark" target="_blank" rel="noopener noreferrer" ref="mylink">
              {{ report.link}}
            </a-->
            
            
            <a ref="mylink" title="select + Ctrl+C">{{report.link}}</a>
          </div>
        </div>
        
               
    </div>
    </div>
      <span class="uk-label uk-label-warning uk-border-rounded uk-margin-bottom" v-if="this.id && pubView.length===0"><h3 v-if="this.$store.getters.Lang==='En'">Искомый материал не найден!</h3><h3 v-else>Searched material not found!</h3></span>
      <button v-if="!this.id && pubView.length===0" class="uk-border-rounded uk-button uk-button-primary uk-button-medium  uk-width-expand uk-width-1-3@m uk-margin-bottom" @click="this.search=''">{{ this.$store.getters.GetText.archive.nores[this.$store.getters.Lang]}}</button><br v-if="pubView.length===0">      
      <button v-if="this.id" class="uk-border-rounded uk-button uk-button-primary uk-button-medium  uk-width-expand uk-width-1-3@m uk-margin-bottom" @click="reloadPage">{{ this.$store.getters.GetText.archive.back[this.$store.getters.Lang]}}</button>
    

  </div>
    <!--ul uk-tab>
      <li v-for="year in uniqueYears" :key="year">
        <a v-on:click="filteredPublications(year)">{{ year }}</a>
      </li>
    </ul>

    <ul class="uk-switcher">
      <li v-for="publication in filteredPublications(year)" :key="publication.id">        
        <h4>{{ publication.title_ru }}</h4>
        <p>{{ publication.author_ru }}</p>
        <p>{{ publication.year }}</p>        
      </li>
    </ul-->
  </div>
        </div>
        
    </div>    
</template>
<script>
import api from '@/api'
import NavBar from '@/components/NavBarArchive.vue'
import LoadStatus from '@/components/LoadSatus.vue'
import ArchiveList from '@/components/ArchiveList.vue'
export default {
  name: 'HomeView',
  data(){
    return{
        year: 2023,        
        publications: [],
        id: null,
        section: null,
        search: "",
        pubShow: null,
        //pubView:[]
    }    
  },
  computed: {
    uniqueYears() {
      var arrays = Array.from(new Set(this.publications.map((pub) => pub.year)));
     //this.year = Math.max(arrays)
      return arrays;
    },
    uniqueSection() {
      var arrays = {'Ru':Array.from(new Set(this.publications.map((pub) => pub.section.Ru))),'En':Array.from(new Set(this.publications.map((pub) => pub.section.En)))};
     //this.year = Math.max(arrays)
      return arrays;
    },
    pubView(){
      if (this.id) {       
              const result = this.publications.filter((pub)=>{
                return pub.publication_id === Number(this.id)
              })
              //this.year=this.pubView.filter((pub) => pub.publication_id === Number(this.id))[0].year
              return result      
                            
          } else if (String(this.search).length>0){
            const lowerSearch = this.search.toLowerCase()
             return this.publications.filter(pub=>{  
              //const { En } = pub.author;
                         
              return ( pub.author.En.toLowerCase().includes(lowerSearch) ||
                      pub.author.Ru.toLowerCase().includes(lowerSearch) ||
                      pub.annotation.En.toLowerCase().includes(lowerSearch) ||
                      pub.annotation.Ru.toLowerCase().includes(lowerSearch) ||
                      pub.title.En.toLowerCase().includes(lowerSearch) ||
                      pub.title.Ru.toLowerCase().includes(lowerSearch)                  
                      ) &&
                      pub.year===Number(this.year)
            })
          } else 
            return this.publications.filter(pub=>{
              return pub.year===Number(this.year)
            })
    },
  },

  components: {
    NavBar,
    LoadStatus,
    ArchiveList},

    methods:{
        reloadPage() {
          window.location.href = window.location.href.split('?')[0];
          document.location.reload()
        },
        printQueryParams() {
            const queryParams = this.$route.query
            //console.log(queryParams)
            return queryParams            
        },

        filteredPublications() {
          if (this.id) {       
              const result = this.publications.filter((pub)=>{
                return pub.publication_id === Number(this.id)
              })
              this.pubShow=result      
              this.year=this.pubView.filter((pub) => pub.publication_id === Number(this.id))[0].year              
          } else if (String(this.search).length>0){
            console.log(this.search)
            const result=this.publications.filter(pub=>{
              return pub.author.En.toLowerCase().includes(this.search.toLowerCase())
            })
            this.pubShow=result            
          } else {
            console.log('fin-else')             
            const result = this.pubView.filter(pub=>{return pub}) 
            this.pubShow= result
          }
        },

        loadData(){
            var $this=this            
            api.post('api/getpub').then(res=>{   
              
                var data=[]                
                res.data.forEach(element => {
                  
                  if (element.files && element.files.length>0){
                    var file_en=null
                    var file_ru=null
                    element.files.forEach(file => {                    
                    if (file.indexOf('_ru.d') !== -1){
                      file_ru={'url':file,'name':file.split('/').at(-1).split(' ')[1].replace(/[0-9]{2}:[0-9]{2}:[0-9]{2}_/, "")}
                      } 
                      if (file.indexOf('_en.d') !== -1){
                      file_en={'url':file,'name':file.split('/').at(-1).split(' ')[1].replace(/[0-9]{2}:[0-9]{2}:[0-9]{2}_/, "")}
                      } 
                    }
                  );
                  }
                  
                  if (element.section){
                  data.push({
                      "id": element.id,
                      "section":  {'id' : element.section, 'En':element.section_ru,'Ru':element.section_en},
                      "publication_id": element.publication_id,
                      "title":  {'En':element.title_ru,'Ru':element.title_en},
                      "author":  {'En':element.author_ru,'Ru':element.author_en},
                      "co_author":  {'En':element.co_author_ru==='null'?'':element.co_author_ru,'Ru':element.co_author_en==='null'?'':element.co_author_en},
                      "annotation":  {'En':element.annotation_ru,'Ru':element.annotation_en},                      
                      "stat":  {'En':element.stat_ru,'Ru':element.stat_en},                                            
                      "stat_id": element.stat_id,
                      "files": element.files,
                      "file_ru": file_ru,
                      "file_en": file_en,
                      "year": element.year,
                      "link":  window.location.href.split('?')[0]+"?pub_id="+element.publication_id
                  }) 
                }
                  //console.log(element.files)                 
                }); 
                //console.log(data)           
                $this.publications=data                
                $this.year=Math.max.apply(null,$this.uniqueYears)

                //$this.filteredPublications()
            }).catch(err=>{
              console.log(err)
            })
        },
    },
    mounted() {
        //console.log(this.printQueryParams())        
        this.id=this.printQueryParams().pub_id?this.printQueryParams().pub_id:null
        this.loadData()        
    },
    updated(){
     
    },
}

</script>
<style scoped>
.uk-margin-xlarge-top{
    margin-top: 100px !important;
}
</style>